import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Col, Layout, Row } from 'antd';

import PdButton from 'components/pd-button';
import { TableList } from 'components/table-list';

import CategorySectionService from 'services/category_section';

import { errHandling } from 'utils';

import './style.scss';

const { Content } = Layout;

export function CategorySection() {
  const [isLoading, setIsLoading] = useState(false);
  const [categorySections, setCategorySections] = useState([]);

  const navigate = useNavigate();

  const buttonAction = (row) => {
    const { id } = row;
    return (
      <Row className="button-table">
        <Col span={12} className="button">
          <PdButton
            className="height-32"
            type="primary"
            full
            onClick={handleEdit.bind(this, id)}>
            Edit
          </PdButton>
        </Col>
      </Row>
    );
  };

  const displaySection = (row) => {
    return (
      <Col span={15}>
        <div className="button-table">
          <Row>{`Section ${categorySections.indexOf(row) + 1}`}</Row>
        </div>
      </Col>
    );
  };

  const columns = [
    {
      name: 'Section',
      cell: displaySection,
      center: true,
    },
    {
      name: 'Title',
      selector: row => row.title,
      center: true,
    },
    {
      name: 'Title (Bahasa)',
      selector: row => row.title_idn,
      center: true,
    },
    {
      name: '',
      cell: buttonAction,
      width: '25%',
    },
  ];

  async function fetchCategorySection() {
    setIsLoading(true);
    try {
      const {
        data: { data = [] },
      } = await CategorySectionService.getCategorySections();
      data.sort(function (a, b) {
        return a.id - b.id;
      });
      setCategorySections(data);
    } catch (error) {
      errHandling(error);
    } finally {
      setIsLoading(false);
    }
  }

  function handleEdit(id) {
    navigate({
      pathname: '/category-sections/edit',
      search: `?id=${id}`,
    });
  }

  useEffect(() => {
    fetchCategorySection();
  }, []);

  return (
    <Layout className="main-container pd-cms-product-section">
      <div className="content">
        <div className="pageTitle">Category Section</div>
        <Content className="pageContent">
          <Row>
            {!isLoading && (
              <TableList
                columns={columns}
                loadingOrder={isLoading}
                orderList={categorySections}
                responsive={false}
              />
            )}
          </Row>
        </Content>
      </div>
    </Layout>
  );
}

export default { CategorySection };
